import { Loader2, LucideProps, PlusIcon, TrashIcon } from "lucide-react";
import { Button, ButtonProps } from "./button";
import { t } from "i18next";
import { cn } from "@/lib/utils";

export type CustomButtonProps = ButtonProps & { label?: string };

export const AddButton = ({ children, label, ...props }: CustomButtonProps) => (
  <Button {...props}>
    {children ? (
      children
    ) : (
      <>
        <PlusIcon className="w-4 h-4 mr-2" />
        {label ?? t("add")}
      </>
    )}
  </Button>
);

export const CancelButton = ({
  children,
  label,
  ...props
}: CustomButtonProps) => (
  <Button variant={"secondary"} {...props}>
    {children ? children : <>{label ?? t("actionCancel")}</>}
  </Button>
);

export const DeleteButton = ({
  children,
  className,
  iconProps: { className: iconClassName, ...iconProps } = {},
  ...props
}: CustomButtonProps & { iconProps?: LucideProps }) => (
  <Button
    type="button"
    variant="ghost"
    className={cn("p-1 gap-2", className)}
    {...props}
  >
    <TrashIcon className={cn("text-gray-500", iconClassName)} {...iconProps} />
    {children}
  </Button>
);

export const SaveButton = ({
  children,
  label,
  ...props
}: CustomButtonProps) => (
  <Button variant={"default"} {...props}>
    {children ? children : <>{label ?? t("saveButton")}</>}
  </Button>
);

export const UpdateButton = ({
  children,
  label,
  ...props
}: CustomButtonProps) => (
  <Button variant={"default"} {...props}>
    {children ? children : <>{label ?? t("formUpdate")}</>}
  </Button>
);

export const LoaderButton = ({
  isLoading,
  children,
  ...props
}: ButtonProps & { isLoading: boolean; loader?: React.ReactNode }) => {
  const loader = props.loader ?? <Loader2 className="animate-spin" />;

  return <Button {...props}>{isLoading ? loader : children}</Button>;
};
